import {
    extractLaunchedBridgeBaseUrl,
    extractLaunchedBridgeNonce,
    extractLaunchedBridgeStatus,
    extractLaunchedIcIdentifiantPublique,
} from '../utils/bridge/desktopLaunchToken';
import { setBridgeEndpoint } from './bridgeEndpoint';
import { setBridgeNonce } from './bridgeNonce';
import { setBridgeLaunchStatus } from './bridgeLaunchStatus';
import { getBridgeCompany, normalizeCompanyId, setBridgeCompany } from './bridgeCompany';

/**
 * Applies the bridge coordinates a launch token carries.
 *
 * Acomba arms the bridge with the launch nonce before it opens the window, so every path that reaches
 * the app has to call this: one that does not leaves the client calling an armed bridge with no nonce,
 * which the bridge answers 401 on every route but /health.
 */
export function applyBridgeLaunchContext(assertion: string | null | undefined): void {
    if (!assertion) return;

    setBridgeCompany(extractLaunchedIcIdentifiantPublique(assertion));
    setBridgeEndpoint(extractLaunchedBridgeBaseUrl(assertion));
    setBridgeNonce(extractLaunchedBridgeNonce(assertion));
    setBridgeLaunchStatus(extractLaunchedBridgeStatus(assertion));
}

/**
 * True unless the assertion names a société other than the one this window has pinned — a reload
 * must never resume a different société's session than the one it belongs to. Shared by
 * tryApplyBridgeLaunchContext below and authRefreshScheduler's redirect fallback, so the rule has
 * one definition instead of two.
 */
export function assertionMatchesPinnedCompany(assertion: string | null | undefined): boolean {
    if (!assertion) return true;

    const pinned = getBridgeCompany();
    const launched = extractLaunchedIcIdentifiantPublique(assertion);
    return !(pinned !== null && launched !== null && normalizeCompanyId(launched) !== pinned);
}

export function tryApplyBridgeLaunchContext(assertion: string | null | undefined): boolean {
    if (!assertion) return true;
    if (!assertionMatchesPinnedCompany(assertion)) return false;

    applyBridgeLaunchContext(assertion);
    return true;
}
